import Resource from '@/api/resources/Resource'

class CaseNotesService extends Resource {
    async findById(laboratoryId, caseId) {
        return this.axios.get(`/laboratories/${laboratoryId}/cases/${caseId}/notes`)
            .then(response => response.data)
    }

    async update(laboratoryId, caseId, clob) {
        return this.axios.put(`/laboratories/${laboratoryId}/cases/${caseId}/notes`, clob)
            .then(response => response.data)
    }
}

export default new CaseNotesService()
